import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import extensions from './eft-history/extensions';
import date from './eft-history/date';
import items from './eft-history/items';

const eftHistory = combineReducers({
  extensions,
  date,
  items,
  isLoading: loadingStatusAccordingToReducer('eftHistoryStatusLoadingStatus'),
});

export default eftHistory;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/eft-history.reducer.js